// Client-side logger. Drops every message in production so the browser
// devtools console stays clean and we never accidentally leak internal state
// to end users via console output. In development, forwards to console so
// devs still see logs while debugging.
//
// If we ever want to ship client errors to a real telemetry sink (Sentry,
// Datadog, custom Worker), swap the production branches here. Until then,
// "no output in prod" is the contract.

const isDev = process.env.NODE_ENV !== "production";

interface LogContext {
  [key: string]: unknown;
}

function fmt(action: string, message: string, context?: LogContext) {
  if (context && Object.keys(context).length > 0) {
    return [`[${action}] ${message}`, context];
  }
  return [`[${action}] ${message}`];
}

export const clientLogger = {
  info(action: string, message: string, context?: LogContext) {
    if (!isDev) return;
    console.log(...fmt(action, message, context));
  },
  warn(action: string, message: string, context?: LogContext) {
    if (!isDev) return;
    console.warn(...fmt(action, message, context));
  },
  error(action: string, message: string, error: unknown, context?: LogContext) {
    if (!isDev) return;
    const errCtx =
      error instanceof Error
        ? { name: error.name, message: error.message, stack: error.stack }
        : { value: String(error) };
    console.error(
      ...fmt(action, message, { error: errCtx, ...(context ?? {}) })
    );
  },
};
